<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h3 class="box-title" style="margin-top: 0px">
          IDENTIFICAÇÃO DO CLIENTE
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <form-helper
          :inputVar="form.tipoCliente"
          :form="form"
          label="Escolha o documento ou a revenda"
          type="radio"
          :options="getTipoCliente()"
        />
      </div>
      <div class="col-md-4" v-if="form.tipoCliente.value == 'cpf'">
        <form-helper
          :inputVar="form.documentoCliente"
          :form="form"
          label="CPF"
          placeholder="Digite"
          validationType="cpf"
          mask="###.###.###-##"
        />
      </div>
      <div class="col-md-4" v-if="form.tipoCliente.value == 'cnpj'">
        <form-helper
          :inputVar="form.documentoCliente"
          :form="form"
          label="CNPJ"
          placeholder="Digite"
          validationType="cnpj"
          mask="##.###.###/####-##"
        />
      </div>
      <div class="col-md-7" v-if="form.tipoCliente.value == 'revenda'">
        <form-helper
          :inputVar="form.cliente"
          :form="form"
          label="Cliente"
          placeholder="Selecione o cliente"
          type="select"
          :options="this.optionsCliente"
        />
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-md-4">
        <form-helper
          :inputVar="form.rendaMensal"
          :form="form"
          type="money"
          label="Renda Mensal"
          placeholder="0,00"
          validationType="Negative"
        />
      </div> -->
      <div class="col-md-4">
        <form-helper
          :inputVar="form.valor"
          :form="form"
          type="money"
          label="Valor para Financiar"
          placeholder="0,00"
          validationType="Negative"
        />
      </div>

      <div class="col-md-3">
        <button
          v-if="!loader"
          type="button"
          class="btn btn-primary btn-simular"
          style="margin-bottom: 15px; width: 100%"
          @click="simularParcela"
        >
          Simular
        </button>

        <Loader v-if="loader" style="margin-top: 20px; margin-left: 20px" />
      </div>
    </div>

    <div v-if="showSimulation">
      <div class="row">
        <div class="col-md-12">
          <h3 class="box-title" style="margin-top: 0px">SIMULAÇÃO</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <form-helper
            :inputVar="formSimulation.valor"
            :form="formSimulation"
            type="money"
            :readonly="true"
            label="Valor para Financiar"
            placeholder="0,00"
          />
        </div>
        <div class="col-md-3">
          <form-helper
            :inputVar="formSimulation.valor"
            :form="formSimulation"
            type="money"
            :readonly="true"
            label="Valor Liberado"
            placeholder="0,00"
          />
        </div>
        <div class="col-xs-6 col-md-3">
          <form-helper
            :inputVar="formSimulation.parcela"
            :form="formSimulation"
            label="Parcela"
            placeholder="Selecione a parcela"
            type="select"
            :options="optionsParcela"
          />
        </div>

        <div class="col-xs-6 col-md-3 hidden">
          <form-helper
            v-if="this.formSimulation.valorParcela.value > 0"
            :inputVar="formSimulation.valorParcela"
            :form="formSimulation"
            type="money"
            :readonly="true"
            label="Valor Parcela"
            placeholder="0,00"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 992px) {
  .btn-simular {
    margin-top: 2.2em;
  }
}
</style>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";
import SolAgoraService from "@/services/SolAgoraService";
import axios from "axios";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SimulationSolAgoraStep1",
  props: {
    precoEUP: { type: Number, default: 0 },
    simulationData: { type: Object, default: null },
  },
  components: {
    FormHelper,
  },
  data() {
    return {
      form: {
        tipoCliente: new this.$formInput(true, "cpf"),
        documentoCliente: new this.$formInput(true),
        valor: new this.$formInput(true),
        cliente: new this.$formInput(false),
        attemptSubmit: false,
      },
      formSimulation: {
        valor: new this.$formInput(true),
        parcela: new this.$formInput(true),
        valorParcela: new this.$formInput(true),
      },
      optionsCliente: [],
      optionsParcela: [],
      showSimulation: false,
      loading: false,
      loader: false,
    };
  },
  created() {
    this.form.valor.value = this.precoEUP;
    this.getClientes();

    if (this.simulationData != null) {
      this.form.tipoCliente.value = this.simulationData.tipoCliente;
      this.form.documentoCliente.value = this.simulationData.documentoCliente;
      this.form.valor.value = this.simulationData.valor;
      this.form.cliente.value = this.simulationData.cliente;

      this.simulations = this.simulationData.simulations;
      this.optionsParcela = this.simulationData.optionsParcela;
      this.formSimulation.valor.value = this.simulationData.valor;
      this.formSimulation.parcela.value =
        this.simulationData.resultadoSimulacao.Prazo;
      this.formSimulation.valorParcela.value =
        this.simulationData.resultadoSimulacao.VlrParcela;

      this.showSimulation = this.simulationData.valorParcela > 0;
    }
  },
  methods: {
    getClientes() {
      this.optionsCliente = [];
      axios
        .get(this.$apiUrl + "Santander.svc/GetClientesPreAnalise", {
          withCredentials: true,
        })
        .then((response) => {
          let clientes = response.data;
          clientes.forEach((element) => {
            let item = {};

            this.optionsCliente.push({
              code: element.clientCode,
              label: element.name,
              document: element.document,
            });
          });
        });
    },

    getTipoCliente: function () {
      return [
        { code: 1, label: "CPF", value: "cpf" },
        { code: 2, label: "CNPJ", value: "cnpj" },
        { code: 3, label: "Seu Cliente", value: "revenda" },
      ];
    },

    async simularParcela() {
      try {
        this.showSimulation = false;

        this.formSimulation.valorParcela.value = 0;

        this.form.attemptSubmit = true;
        if (this.formErrors !== 0) return;

        this.loader = true;
        const auth = await SolAgoraService.GetToken({ apiUrl: this.$apiUrl });

        if (!auth) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return false;
        }

        const token = auth.data.AccessToken;

        const documento = this.form.cliente.value.document
          ? this.form.cliente.value.document
          : this.form.documentoCliente.value;

        const res = await SolAgoraService.OpenSimulate({
          apiUrl: this.$apiUrl,
          token: token,
          price: this.form.valor.value,
          monthly_income: 1000000,
          document: documento,
        });
        
        if (!res) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return;
        }

        if (res.message) {
          swal({
            title: "Aviso",
            text: res.message,
            icon: "warning",
          });
          return;
        }

        if (res.data.Parcelas && res.data.Parcelas.length) {
          this.simulations = res.data.Parcelas;

          const parcelas = res.data.Parcelas.sort(
            (x, y) => x.VlrParcela - y.VlrParcela
          );

          this.formSimulation.valor.value = this.form.valor.value;

          this.optionsParcela = res.data.Parcelas.map((x) => ({ code: x.Prazo, label: `${x.Prazo} x R$ ${x.VlrParcela.toFixed(2).replace('.', ',')}` }));
          this.formSimulation.parcela.value = { code: parcelas[0].Prazo, label: `${parcelas[0].Prazo} x R$ ${parcelas[0].VlrParcela.toFixed(2).replace('.', ',')}` };
          this.formSimulation.valorParcela.value = parcelas[0].VlrParcela;

          this.showSimulation = true;

          this.$emit("updateSimulationData", {
            tipoCliente: this.form.tipoCliente.value,
            documentoCliente: this.form.documentoCliente.value,
            valor: this.form.valor.value,
            cliente: this.form.cliente.value,

            valor: this.formSimulation.valor.value,
            parcela: this.formSimulation.parcela.value,
            valorParcela: this.formSimulation.valorParcela.value,

            optionsParcela: this.optionsParcela,
            simulations: this.simulations,
            resultadoSimulacao: this.simulations.filter(
              (x) => x.Prazo == this.formSimulation.parcela.value
            )[0],
          });
        }
      } finally {
        this.loader = false;
      }
    },

    nextStep: async function () {
      this.loading = true;

      try {
        this.form.attemptSubmit = true;

        if (this.formErrors !== 0) return;

        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "formSimulation.parcela.value": function (val) {
      if (val) {
        const parcela = this.simulations.filter((x) => x.Prazo == val.code)[0];
        this.formSimulation.valorParcela.value = parcela.VlrParcela;

        this.$emit("updateParcela", {
          resultadoSimulacao: parcela,
        });
      }
    },

    "form.tipoCliente.value": function (val) {
      if (val !== "revenda") {
        this.form.cliente = new this.$formInput(false);
        this.form.documentoCliente = new this.$formInput(true);
      } else {
        this.form.cliente = new this.$formInput(true);
        this.form.documentoCliente = new this.$formInput(false);
      }
    },
  },
  computed: {
    formErrors: function () {
      const errors = Object.keys(this.form).filter(
        (key) => this.form[key].validation && !this.form[key].validation.status
      );
      return errors.length;
    },
  },
};
</script>